import * as $ from "jquery";
import CartFieldsStep3 from "../Fields/CartFieldsStep3";
import {Step3Selectors} from 'Components/Cart/Step3/Step3Selectors';
import {calculateWindowOffset} from "../../Functions/CalculateWindowOffset";

export default class Step3FormValidation
{
    readonly Selector: any;

    constructor()
    {
        this.validate = this.validate.bind(this);
        this.Selector = {
            FORM : Step3Selectors.COMMON.FORM
        }
    }

    public validate()
    {
        let rules = Object.assign({},
            CartFieldsStep3.getFields(this.Selector),
        )

        $(this.Selector.FORM).validate({
            rules: rules,
            errorElement: 'div',
            errorClass:   'invalid-feedback',
            highlight: function(element, errorClass){
                $(element).parent().find('label').addClass('invalid-feedback-custom-label-error');
            },
            unhighlight: function(element, errorClass){
                $(element).parent().find('label').removeClass('invalid-feedback-custom-label-error');
            },
            invalidHandler: function (form, validator) {
                if (!validator.numberOfInvalids()){
                    return;
                }
                $('html, body').animate({
                    scrollTop: $(validator.errorList[0].element).offset().top - calculateWindowOffset()
                }, 600);
            }
        });

        return $(this.Selector.FORM).valid();
    }
}
import * as $ from "jquery";
import CartFieldsStep3 from "../Fields/CartFieldsStep3";
import {Step3Selectors} from 'Components/Cart/Step3/Step3Selectors';
import {calculateWindowOffset} from "../../Functions/CalculateWindowOffset";

export default class Step3FormValidation
{
    readonly Selector: any;

    constructor()
    {
        this.validate = this.validate.bind(this);
        this.Selector = {
            FORM : Step3Selectors.COMMON.FORM
        }
    }

    public validate()
    {
        let rules = Object.assign({},
            CartFieldsStep3.getFields(this.Selector),
        )

        $(this.Selector.FORM).validate({
            rules: rules,
            errorElement: 'div',
            errorClass:   'invalid-feedback',
            highlight: function(element, errorClass){
                $(element).parent().find('label').addClass('invalid-feedback-custom-label-error');
            },
            unhighlight: function(element, errorClass){
                $(element).parent().find('label').removeClass('invalid-feedback-custom-label-error');
            },
            invalidHandler: function (form, validator) {
                if (!validator.numberOfInvalids()){
                    return;
                }
                $('html, body').animate({
                    scrollTop: $(validator.errorList[0].element).offset().top - calculateWindowOffset()
                }, 600);
            }
        });

        return $(this.Selector.FORM).valid();
    }
}
